import { Metadata, PropertiesModel } from "../shared/models/metadata.model";
import { SourceItem } from "../shared/models/source-item.model";
/***
* Loads a cart from local storage.
*/
export function loadCart(site: string): Array<SourceItem> {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return [];
    }
    return JSON.parse(localStorage?.getItem(`${site}.download-cart`) || "[]");
}

/***
 * Saves a cart to local storage.
 */
export function saveCart(cart: Array<SourceItem>, site: string): void {
    localStorage.setItem(`${site}.download-cart`, JSON.stringify(cart));
}

/***
 * Builds a cart item based on the current state.
 * The state includes the path and the metadata for the current file, and the current filters.
 */
export function buildCartItem(path: string, metadata: Metadata | undefined, validity: string, system: PropertiesModel): SourceItem | null {

    if (path) {
        const item: SourceItem = {
            value: path,
            props: {
                system: {
                    title: [metadata?.title || ""],
                },
                other: {
                    validityFilter: [validity || ""],
                }
            },
        };
        if (system.lang?.[0]?.toString()) {
            item.props.system.lang = [system.lang?.[0]?.toString()];
        }
        if (system.edition?.[0]?.toString()) {
            item.props.system.edition = [system.edition?.[0]?.toString()];
        }
        return item;
    }
    return null;
}